import request from '../utils/Request';
import { Methods } from '../config';
import { downloadFile } from '../utils/download';

const baseURL = 'bi/dashboard';

const dashboardService = {
  getDashboard(id) {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  async downloadDashboardPdf(id, data) {
    const pdf = await request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(id)}/pdf`,
      data,
      responseType: 'blob',
    });

    return downloadFile(pdf, pdf.filename || `dashboard-${id}.pdf`);
  },

  upsertDashboard(data) {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  getDashboardList(data) {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/list`,
      data,
    });
  },

  allDashboards: () => {
    return request({
      resource: `${baseURL}/allDashboards`,
    });
  },

  getBusinessPartners: (slpCode) => {
    return request({
      resource: `${baseURL}/businessPartners/${slpCode ? encodeURIComponent(slpCode) : ''}`,
    });
  },

  getCustom1Values: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/custom1Values`,
    });
  },

  deleteDashboard: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  getResponsibles: (type) => {
    return request({
      resource: `${baseURL}/responsibles/${encodeURIComponent(type)}`,
    });
  },
};

export default dashboardService;
